import {
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  numberedEnv,
  isNumberedEnv,
  sentryDsn,
  amplitudeAPIKey,
  muiProKey,
} from "@src/runtime-config-base";
import { RuntimeConfig } from "@src/runtime-config-types";

export const runtimeConfig: RuntimeConfig = {
  environment: "dev",
  appRegion: "com",
  appEnv: "com-dev",
  displayAppEnv: "Dev INTL",
  urls: {
    apiUrl: "https://core.api.dev.holobuilder.com",
    baseUrl: "https://admin.dev.holobuilder.com",
    dashboardUrl: "https://sphere.dev.holobuilder.com",
    webEditorUrl: "https://app.dev.holobuilder.com/app",
    entryPageUrl: "https://entry.dev.holobuilder.com",
    adminPanelApi: "https://admin.dev.holobuilder.com/api",
    cookieManagerUrl:
      "https://cookies.dev.holobuilder.com/cookie-manager/manager/latest",
  },
  features: {
    muiProKey,
    amplitudeAPIKey,
  },
  keys: {
    sentryDsn,
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support+dev@holobuilder.com",
  isNumberedEnv,
  numberedEnv,
};
